import { PersistentCache } from "../offline/persistent_cache.js";
import type { ConfigHashMap } from "./config_staleness.js";

const STORAGE_KEY = "config_hashes_v1";

export type { ConfigHashMap };

export class ConfigHashStore
{
  private static hashes: ConfigHashMap | null = null;

  public static getAll(): ConfigHashMap
  {
    if ( !this.hashes )
    {
      const raw = PersistentCache.read<ConfigHashMap>( STORAGE_KEY );
      this.hashes = raw && typeof raw === "object" && !Array.isArray( raw ) ? { ...raw } : {};
    }
    return this.hashes;
  }

  public static get( type: string ): string | null
  {
    return this.getAll()[type] ?? null;
  }

  public static set( type: string, hash: string ): void
  {
    const all = this.getAll();
    if ( all[type] === hash ) return;
    all[type] = hash;
    PersistentCache.write( STORAGE_KEY, all );
  }

  public static remove( type: string ): void
  {
    const all = this.getAll();
    if ( !( type in all ) ) return;
    delete all[type];
    PersistentCache.write( STORAGE_KEY, all );
  }

  public static clear(): void
  {
    this.hashes = {};
    PersistentCache.remove( STORAGE_KEY );
  }

  public static normalizeEtag( etag: string | null ): string | null
  {
    if ( !etag ) return null;
    const trimmed = etag.trim().replace( /^W\//, "" ).replace( /^"|"$/g, "" ).replace( /\+mp$/, "" );
    return trimmed.length > 0 ? trimmed : null;
  }
}
